import { Popover } from "flowbite-react";
import { ArrowBigDown, ArrowBigUp } from "lucide-react";
import { FaEquals, FaInfoCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

type CardTmiProps = {
  value?: number;
  delta?: number;
};

const CardTmi = (props: CardTmiProps) => {
  const navigate = useNavigate();

  const handleClickTMI = () => {
    const statusUrl = `/operational-management`;

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      navigate(statusUrl);
    } else {
      window.open(statusUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`relative bg-white border border-gray5 shadow-md rounded-2xl p-5 transition hover:shadow-lg hover:scale-[1.01] animate-pulse font-semibold ${(props.value ?? 0) > 10 ? "animate-pulse-color" : ""}`}
      id="card-tmi"
    >
      <div className="grid grid-cols-[1fr_auto] gap-4 items-center justify-center">
        <div className="flex flex-col justify-center items-center">
          <div className="mb-2 flex items-center gap-2">
            <h3 className={`text-xl font-semibold`}>
              TMI
            </h3>
            <Popover
              content={
                <div className="text-black border border-gray-300 rounded-md shadow-md p-2 max-w-sm relative z-40">
                  <span className="text-sm">{`Tempo Médio na Base`}</span>
                </div>
              }
              placement="top"
              trigger="click"
            >
              <div className="cursor-pointer text-black" role="button-operational-management-group">
                <FaInfoCircle className="text-black" />
              </div>
            </Popover>
          </div>
          <a
            onClick={handleClickTMI}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline hover:text-blue-500 cursor-pointer"
          >
            <p
              className={`text-3xl font-semibold ${(props.value ?? 0) > 10 ? 'animate-text-color' : ''}`}
            >
              {(props.value ?? 0).toFixed(2).replace(".", ",")}
            </p>
          </a>
        </div>
        <div className="flex flex-col justify-between items-end h-full gap-2 items-center">
          {props.delta !== undefined && (
            props.delta === 0 ? (
              <FaEquals className={`w-6 h-6 text-slate-400 fill-current stroke-none`} />
            ) : props.delta > 0 ? (
              <ArrowBigUp className={`w-12 h-12 text-red-600 animate-pulse-arrow-red fill-current stroke-none`} />
            ) : (
              <ArrowBigDown className={`w-12 h-12 text-green-600 animate-pulse-arrow-green fill-current stroke-none`} />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CardTmi;
